import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
  name: 'donorCountFormat',
  standalone: true
})
export class DonorCountFormatPipe implements PipeTransform {

  transform(value: number | null | undefined): string {
    if (value == null || isNaN(value)) return '';
    const num = Math.floor(value);
    if (num < 100) return num.toString();
    if (num < 500) return '100+';
    if (num < 1000) return '500+';
    const bucket = Math.floor(num / 1000) * 1000;
    return `${bucket.toLocaleString()}+`;
  }

}
